import { render, staticRenderFns } from "./TransferStakesModal.vue?vue&type=template&id=7e2473ea&"
import script from "./TransferStakesModal.vue?vue&type=script&lang=js&"
export * from "./TransferStakesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports